import { useState } from 'react';
import { Plus } from 'lucide-react';

import { PageShell } from '@/components/layout/PageShell';
import { ProjectList } from '@/components/projects/ProjectList';
import { NewProjectDialog } from '@/components/projects/NewProjectDialog';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/hooks/useAuth';
import { sectionNumber } from '@/lib/utils';

/**
 * /projects page. Authed-only — wrapped in <RequireAuth> in routes.tsx.
 *
 * Editorial header followed by the project grid. Single CTA: "New project".
 */
export function ProjectsPage() {
  const { user } = useAuth();
  const [creating, setCreating] = useState(false);

  return (
    <PageShell>
      <section className="grid grid-cols-12 gap-6 pt-8">
        <div className="col-span-12 md:col-span-2">
          <p className="marginalia">
            <span className="mr-2">{sectionNumber(1)}</span>
            your projects
          </p>
        </div>

        <div className="col-span-12 md:col-span-10">
          <div className="flex flex-wrap items-end justify-between gap-4">
            <div>
              <h1 className="font-serif text-display-lg text-ink">
                {user?.displayName ? `${user.displayName}'s` : 'Your'}{' '}
                <span className="italic text-graphite">workshop.</span>
              </h1>
              <p className="mt-3 max-w-xl text-base leading-relaxed text-graphite">
                Each project carries its questionnaire answers, lo-fi
                sketches, agent outputs, and final artefacts. Open one to
                continue, or start a new project below.
              </p>
            </div>

            <Button onClick={() => setCreating(true)} size="lg">
              <Plus className="h-4 w-4" />
              New project
            </Button>
          </div>

          <div className="mt-12 h-px bg-ink/20" />

          <div className="mt-10">
            <ProjectList onCreateClick={() => setCreating(true)} />
          </div>
        </div>
      </section>

      <NewProjectDialog open={creating} onOpenChange={setCreating} />
    </PageShell>
  );
}
